import { css } from 'styled-components';
import { text2, text1, header4 } from '@ardoq/typography';

export const pageViewLargeTemp = css`
  ${text2};
  font-size: 32px;
  line-height: 48px;
`;

export const PAGE_VIEW_MEDIUM_TEMP_FONT_SIZE = '16px';
export const PAGE_VIEW_MEDIUM_TEMP_LINE_HEIGHT = '24px';
export const pageViewMediumTemp = css`
  ${text2};
  font-size: ${PAGE_VIEW_MEDIUM_TEMP_FONT_SIZE};
  line-height: ${PAGE_VIEW_MEDIUM_TEMP_LINE_HEIGHT};
`;
export const smallItalicTemp = css`
  ${text2}
  font-style: italic;
`;

export const mediumItalicTemp = css`
  ${text2}
  font-style: italic;
  font-size: 16px;
  line-height: 24px;
`;

export const pageViewSmallTemp = css`
  ${text2};
  font-size: 14px;
  line-height: 22px;
`;

export const pageViewExtraSmallTemp = css`
  ${text2};
  font-size: 12px;
  line-height: 20px;
`;

export const scenarioMergeSidebarHeaderTemp = css`
  ${text1}
  text-transform: uppercase;
`;

export const scenarioMergeSidebarStepNameTemp = css`
  ${text2}
  line-height: 24px;
  text-transform: capitalize;
`;

export const scenarioMergeSidebarStepNameActiveTemp = css`
  ${header4}
  text-transform: capitalize;
`;
